import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Image,
  NavigationHeader,
  Link,
  Separator,
  Text,
  OverlayProvider,
} from "@pingux/astro";
import { menuItems, HEADER_LOGO, DISPLAY_NAME } from "./HeaderConfig";
import HelpButton from "./HelpButton";
import { headerSX } from "./HeaderSX";
import { PING_IDENTITY_URL } from "utils/constants";
import { useAuthContext } from "state/context/AuthContext";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    state: { isAuthenticated, user },
    dispatch,
  } = useAuthContext();
  const userName = user?.email || user?.name || "Unknown";

  const handleLogout = () => {
    dispatch({ type: "UNAUTHENTICATED" });
    window.location.assign("/api/auth/logout");
  };

  return (
    <NavigationHeader
      sx={headerSX.headerContainer}
      aria-labelledby="tap-dashboard-header"
    >
      <Box
        isRow
        alignItems="center"
        justifyContent="center"
        py="sm"
        flex="0 0 auto"
      >
        <Link target="_blank" href={PING_IDENTITY_URL}>
          <Image
            src={HEADER_LOGO}
            alt="Ping Identity Logo"
            mr="md"
            sx={{
              height: "24px",
              cursor: "pointer",
            }}
          />
        </Link>

        <Separator
          orientation="vertical"
          style={{
            height: "28px",
            margin: "0",
          }}
        />
        <Link variant="navigationHeader.logoBand" onPress={() => navigate("/")}>
          <Text
            as="h2"
            variant="navigationHeader.headerPlaceholder"
            id="tap-dashboard-header"
            sx={{
              cursor: "pointer",
              color: "rgba(0,0,0,0.9)",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {DISPLAY_NAME}
          </Text>
        </Link>
      </Box>

      {isAuthenticated && (
        <Box
          isRow
          alignItems="center"
          sx={{ gap: "0.25rem", marginLeft: "md" }}
        >
          {[
            { label: "Pipelines", path: "/" },
            { label: "Open SaaS PRs", path: "/saas-prs" },
          ].map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Text
                key={item.path}
                as="span"
                onClick={() => navigate(item.path)}
                sx={{
                  fontSize: "0.8125rem",
                  fontWeight: isActive ? 700 : 500,
                  color: isActive ? "#1d4ed8" : "rgba(0,0,0,0.65)",
                  cursor: "pointer",
                  padding: "0.375rem 0.75rem",
                  borderRadius: "0.375rem",
                  backgroundColor: isActive ? "rgba(59,130,246,0.08)" : "transparent",
                  transition: "all 0.15s",
                  "&:hover": {
                    color: "#1d4ed8",
                    backgroundColor: "rgba(59,130,246,0.06)",
                  },
                }}
              >
                {item.label}
              </Text>
            );
          })}
        </Box>
      )}

      <OverlayProvider>
        <Box
          as="ul"
          isRow
          alignItems="center"
          p="0"
          ml="auto"
          flex="0 0 auto"
          sx={{ gap: "0.75rem" }}
        >
          {isAuthenticated && (
            <Box sx={{ textAlign: "right", lineHeight: "1.2" }}>
              <Text
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "600",
                  color: "rgba(0,0,0,0.85)",
                  display: "block",
                }}
              >
                {userName}
              </Text>
            </Box>
          )}
          <HelpButton
            items={menuItems}
            onLogout={isAuthenticated ? handleLogout : undefined}
          />
        </Box>
      </OverlayProvider>
    </NavigationHeader>
  );
};

export default Header;
